<div class="email-preview-frame">
	<div class="toolbar" *ngIf="showDeviceToggle">
		<p-selectButton
			[options]="deviceOptions"
			optionLabel="label"
			optionValue="value"
			[allowEmpty]="false"
			[ngModel]="device"
			(ngModelChange)="setDevice($event)"
		></p-selectButton>
	</div>
	<div class="stage">
		<div class="empty" *ngIf="isEmpty; else frame">Nothing to preview yet</div>
		<ng-template #frame>
			<iframe
				class="frame"
				[class.frame-desktop]="device !== 'mobile'"
				[class.frame-mobile]="device === 'mobile'"
				sandbox=""
				referrerpolicy="no-referrer"
				title="Email preview"
				[attr.srcdoc]="safeHtml"
			></iframe>
		</ng-template>
	</div>
</div>
